import { createUploadthingClient } from '@travel-planner/uploadthing/client';
import { getAuthToken } from '@/shared/api/trpc';

const apiUrl = `${import.meta.env.VITE_API_URL || 'http://localhost:3001'}/api/uploadthing`;

export const { useUploadThing, uploadFiles } = createUploadthingClient({
  apiUrl,
  getAuthToken,
});
